import React, { useState, useEffect } from 'react';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const HeroSection = () => {
  const { language } = useLanguage();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1695222833131-54ee679ae8e5?w=1920&q=80',
      title_tr: { line1: 'Değerli', line2: 'Olanı', line3: 'Taşıyoruz' },
      title_en: { line1: 'We Move', line2: 'What', line3: 'Matters' },
      subtitle_tr: 'Türkiye genelinde lojistik, nakliye ve taşımacılık hizmetleri sunan köklü bir firmayız.',
      subtitle_en: 'A well-established company providing logistics, freight and transportation services throughout Turkey.'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1644079446600-219068676743?w=1920&q=80',
      title_tr: { line1: 'Hızlı', line2: 've Güvenli', line3: 'Taşıma' },
      title_en: { line1: 'Fast', line2: 'and Secure', line3: 'Transport' },
      subtitle_tr: 'Modern araç filosu ve deneyimli ekibimizle hızlı, güvenli çözümler sunuyoruz.',
      subtitle_en: 'We offer fast and secure solutions with our modern fleet and experienced team.'
    }
  ];

  const currentContent = slides[currentSlide];
  const title = language === 'tr' ? currentContent.title_tr : currentContent.title_en;
  const subtitle = language === 'tr' ? currentContent.subtitle_tr : currentContent.subtitle_en;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000); // 10 saniye

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };
  
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Images with Transition */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 z-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt="Logistics"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#36344D]/95 via-[#36344D]/85 to-transparent"></div>
        </div>
      ))}

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10 pt-32">
        <div className="max-w-3xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fadeIn">
            {title.line1}{' '}
            <span className="text-[#DF6A6A]">{title.line2}</span>
            <br />
            {title.line3}
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 mb-10 animate-fadeIn">
            {subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fadeIn">
            <a
              href="#services"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#36344D] rounded-md hover:bg-gray-100 transition-all duration-300 font-semibold group"
            >
              {language === 'tr' ? 'Servislerimiz' : 'Our Services'}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#quote"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#DF6A6A] text-white rounded-md hover:bg-[#c55555] transition-all duration-300 font-semibold"
            >
              {language === 'tr' ? 'Teklif Al' : 'Get Quote'}
            </a>
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/40 text-white p-3 rounded-full backdrop-blur-sm transition-all"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/40 text-white p-3 rounded-full backdrop-blur-sm transition-all"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 z-20 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-[#DF6A6A] w-8' : 'bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;